import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const ChevronLeftIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="chevronLeft" ref={ref as any} {...props}>
      <path
        d="M7.2389 11.2179L14.5896 4.2295C14.9122 3.92353 15.4347 3.92353 15.7581 4.2295C16.0806 4.53547 16.0806 5.03246 15.7581 5.33843L8.99043 11.7723L15.7573 18.2062C16.0798 18.5122 16.0798 19.0092 15.7573 19.3159C15.4347 19.6219 14.9113 19.6219 14.5888 19.3159L7.23809 12.3276C6.9205 12.0248 6.9205 11.52 7.2389 11.2179Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
});
